import {
  UsersResponse as Response,
  Uri,
  UserListData,
  UserListQueryParams,
  convertUserList,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import qs from 'qs'
import keys from './shared/keys'

const TEXT_ONLY_CREW_SIZE = 20

export function useUserList(
  params: UserListQueryParams,
  storeId: string | undefined,
  enabled = true
) {
  const { server } = useServer()
  const uri = getUri()

  return useQuery({
    queryKey: uri ? keys.list(uri) : [],
    queryFn: fetchUserList,
    enabled: !!storeId && enabled,
  })

  async function fetchUserList(): Promise<UserListData> {
    const url = uri

    if (!url) {
      throw new Error('Illegal user list URL')
    }

    const response = await server.get<Response.UserList>(url)
    return convertUserList(response)
  }

  function getUri(): Uri | undefined {
    if (!storeId) {
      return
    }

    let queryString = ''

    queryString = qs.stringify(params)

    return `/v2/managers/me/stores/${storeId}/users?${queryString}`
  }
}

export function useTextOnlyUsers(activeStoreId?: string, enabled = false) {
  const userListQuery = useUserList(
    { type: 'text_only_download_reminder', size: TEXT_ONLY_CREW_SIZE },
    activeStoreId,
    enabled
  )

  return userListQuery.data?.users
}
